
document.addEventListener('DOMContentLoaded', function() {
    if (window.location.hash) {
        const hash = window.location.hash;
        if (hash.startsWith('#apps-')) {
            activateTab(hash);
            scrollToTabs();
        }
    }
});

document.querySelectorAll('a[href^="#apps-"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
        e.preventDefault();
        const hash = this.getAttribute('href');
        activateTab(hash);
        scrollToTabs();
    });
});

function scrollToTabs() {
    setTimeout(function() {
        const tabsSection = document.querySelector('.inline-filter');
        if (tabsSection) {
            const rect = tabsSection.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const offsetPosition = rect.top + scrollTop - 80;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    }, 100);
}

function activateTab(hash) {
    const tabButton = document.querySelector(`button[data-bs-target="${hash}"]`);

    if (!tabButton) return;

    document.querySelectorAll('#apps-tab button').forEach(function(btn) {
        btn.classList.remove('active');
        btn.setAttribute('aria-selected', 'false');
    });

    document.querySelectorAll('.tab-pane').forEach(function(pane) {
        pane.classList.remove('show', 'active');
    });

    tabButton.classList.add('active');
    tabButton.setAttribute('aria-selected', 'true');

    const targetPane = document.querySelector(hash);
    if (targetPane) {
        targetPane.classList.add('show', 'active');
    }
}


document.addEventListener('DOMContentLoaded', function() {
    const filterNav = document.querySelector('.filter-nav');
    const filterButton = document.querySelector('.filter-control');
    const tabButtons = document.querySelectorAll('.filter-nav button[data-bs-toggle="pill"]');

    tabButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            if (window.innerWidth < 992) {
                filterNav.classList.remove('show');

                filterButton.classList.add('collapsed');
                filterButton.setAttribute('aria-expanded', 'false');
            }
        });
    });
});